export const OrderDNATestFormConfig = {
    acceptedExtensions: ".jpg,.jpeg,.pdf",
    maxDocumentsCount: 10,
    maxFilesSizeMb: 30,
};